import { CAMPAIGNS_GROUP_STATUS } from '../../../../config';

// TODO DEV-142896-remove-shared-budget-from-ui-gw
export const isCampaignGroupDeleted = campaignGroup =>
    campaignGroup?.status === CAMPAIGNS_GROUP_STATUS.TERMINATED ||
    campaignGroup?.displayStatus === CAMPAIGNS_GROUP_STATUS.TERMINATED;
